import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { useTranslation } from 'react-i18next';
import Checkbox from '@mui/material/Checkbox';
import { SxProps, Box, FormControlLabel } from '@mui/material';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import FilterItem from './FilterItem';

type GeneralCustomerListFilterDialogProps = {
  open: boolean;
  onClose: () => void;
  tourGroupOptions?: string[];
  selectedTourGroups?: string[];
  setSelectedTourGroups?: React.Dispatch<React.SetStateAction<string[]>>;
  salesGroupOptions?: string[];
  selectedSalesGroups?: string[];
  setSelectedSalesGroups?: React.Dispatch<React.SetStateAction<string[]>>;
  salesIndividualStatusOptions?: string[];
  selectedSalesIndividualStatus?: string[];
  setSelectedSalesIndividualStatus?: React.Dispatch<
    React.SetStateAction<string[]>
  >;
  sx?: SxProps;
};

export default function GeneralCustomerListFilterDialog({
  open,
  onClose,
  tourGroupOptions,
  selectedTourGroups,
  setSelectedTourGroups,
  salesGroupOptions,
  selectedSalesGroups,
  setSelectedSalesGroups,
  salesIndividualStatusOptions,
  selectedSalesIndividualStatus,
  setSelectedSalesIndividualStatus,
}: GeneralCustomerListFilterDialogProps) {
  const { t } = useTranslation();

  const handleTourGroupChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const value = event.target.name;
    if (setSelectedTourGroups) {
      setSelectedTourGroups((prev) =>
        prev.includes(value)
          ? prev.filter((item) => item !== value)
          : [...prev, value],
      );
    }
  };

  const handleSalesOfficeChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const value = event.target.name;
    if (setSelectedSalesGroups) {
      setSelectedSalesGroups((prev) =>
        prev.includes(value)
          ? prev.filter((item) => item !== value)
          : [...prev, value],
      );
    }
  };

  const handleSalesIndividualStatusChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const value = event.target.name;
    if (setSelectedSalesIndividualStatus) {
      setSelectedSalesIndividualStatus((prev) =>
        prev.includes(value)
          ? prev.filter((item) => item !== value)
          : [...prev, value],
      );
    }
  };

  return (
    <Dialog
      onClose={onClose}
      aria-labelledby="customized-dialog-title"
      open={open}
      PaperProps={{
        sx: {
          width: '80%',
          maxWidth: '800px',
        },
      }}
    >
      <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
        {t('onlineTourFiltering.Filter')}
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        {tourGroupOptions && (
          <FilterItem title={t('guideCustomerDialog.searchTourGroup')}>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'start',
              }}
            >
              {tourGroupOptions &&
                tourGroupOptions.map((option) => (
                  <FormControlLabel
                    key={option}
                    control={
                      <Checkbox
                        checked={selectedTourGroups?.includes(option)}
                        onChange={handleTourGroupChange}
                        name={option}
                        icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                        checkedIcon={<CheckBoxIcon fontSize="small" />}
                      />
                    }
                    label={option}
                  />
                ))}
            </Box>
          </FilterItem>
        )}
        <FilterItem title={t('guideCustomerDialog.searchSalesOffice')}>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'start',
            }}
          >
            {salesGroupOptions &&
              salesGroupOptions.map((option) => (
                <FormControlLabel
                  key={option}
                  control={
                    <Checkbox
                      checked={selectedSalesGroups?.includes(option)}
                      onChange={handleSalesOfficeChange}
                      name={option}
                      icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                      checkedIcon={<CheckBoxIcon fontSize="small" />}
                    />
                  }
                  label={option}
                />
              ))}
          </Box>
        </FilterItem>
        {salesIndividualStatusOptions && (
          <FilterItem title={t('guidanceTourPayment.cancelled')}>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'start',
              }}
            >
              {salesIndividualStatusOptions &&
                salesIndividualStatusOptions.map((option) => (
                  <FormControlLabel
                    key={option}
                    control={
                      <Checkbox
                        checked={selectedSalesIndividualStatus?.includes(
                          option,
                        )}
                        onChange={handleSalesIndividualStatusChange}
                        name={option}
                        icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                        checkedIcon={<CheckBoxIcon fontSize="small" />}
                      />
                    }
                    label={option}
                  />
                ))}
            </Box>
          </FilterItem>
        )}
      </DialogContent>
      <DialogActions>
        <Button autoFocus onClick={onClose}>
          {t('guideCustomerDialog.record')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
